
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Vishrantwaditomumbaicab() {



    const cardData =
    {
        keyword: 'Vishrantwadi to Mumbai Cab',
        heading: 'Skyline Cabs: Vishrantwadi to Mumbai Cab',
        headingDescription: 'Skyline Cabs offers reliable and affordable Vishrantwadi to Mumbai Cab services for a smooth and stress-free journey. Whether you are heading to Mumbai for work, leisure, or an airport transfer, our well-maintained vehicles and experienced drivers ensure a safe and timely ride. With transparent pricing, round-the-clock availability, and a focus on customer satisfaction, Skyline Cabs is your trusted travel partner from Vishrantwadi to Mumbai. Book your cab today for a comfortable and convenient experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Vishrantwadi to Mumbai Cab Price",
      "description": "Skyline Cabs provides affordable cab services from Vishrantwadi to Mumbai with clear and upfront pricing. Our service ensures a smooth and punctual ride, whether you’re heading to Mumbai city or the airport."
    },
    {
      "name": "Dhanori to Mumbai Cab Service",
      "description": "Travel from Dhanori to Mumbai with Skyline Cabs for a hassle-free and safe journey. Choose from our range of vehicles including sedans, Ertiga, and Innova Crysta for a ride that suits your needs and budget."
    },
    {
      "name": "Vishrantwadi to Mumbai Airport Cab",
      "description": "Skyline Cabs offers reliable airport transfers from Vishrantwadi to Mumbai Airport. Enjoy on-time pickups, professional drivers, and options like Ertiga or Innova Crysta for a comfortable travel experience."
    },
    {
      "name": "Vishrantwadi to Dadar Cab",
      "description": "Book a cab with Skyline Cabs from Vishrantwadi to Dadar for a seamless intercity travel experience. Our vehicles are clean, well-maintained, and driven by courteous professionals who ensure a safe ride."
    },
    {
      "name": "Mumbai to Vishrantwadi Cab",
      "description": "Need a cab back from Mumbai to Vishrantwadi? Skyline Cabs offers one-way and round-trip bookings with flexible timings and a wide selection of vehicles at competitive prices."
    },
    {
      "name": "Bhosari to Mumbai Cabs",
      "description": "Skyline Cabs provides smooth and economical cab services from Bhosari to Mumbai. Whether you're heading to the city or the airport, our fleet of vehicles and trained drivers ensure a stress-free ride."
    },
    {
      "name": "Bhosari to Mumbai Cabs Service",
      "description": "Travel from Bhosari to Mumbai with ease using Skyline Cabs. Our service is ideal for business travelers and families, with 24/7 availability, GPS-enabled cars, and experienced drivers."
    },
    {
      "name": "Cab Service in Dhanori",
      "description": "Skyline Cabs offers dependable taxi services in Dhanori for local travel or long-distance trips to Mumbai. We offer well-maintained sedans, SUVs, and luxury cabs at transparent rates."
    },
    {
      "name": "Cab Service in Vishrantwadi",
      "description": "Looking for a cab in Vishrantwadi? Skyline Cabs provides full-service transportation solutions with a choice of vehicles and 24/7 booking support for local and intercity routes."
    },
    {
      "name": "Taxi Service in Vishrantwadi",
      "description": "Get quick and reliable taxi service in Vishrantwadi with Skyline Cabs. From airport drops to Mumbai city rides, our services are designed to make your commute smooth and affordable."
    },
    {
      "name": "Innova Crysta on Rent in Vishrantwadi",
      "description": "Rent a spacious Innova Crysta in Vishrantwadi for trips to Mumbai or outstation travel. Ideal for family trips, this 7-seater ensures comfort, AC, and extra luggage space."
    },
    {
      "name": "Innova Crysta Hire In Bhosari",
      "description": "Hire an Innova Crysta from Bhosari for outstation travel, Mumbai airport transfers, or business trips. Skyline Cabs guarantees professional service and competitive pricing."
    },
    {
      "name": "Ertiga on Rent in Vishrantwadi",
      "description": "Need a 6-7 seater cab in Vishrantwadi? Skyline Cabs offers Ertiga on rent, perfect for airport drops, family trips, and group travel to Mumbai or nearby cities."
    },
    {
      "name": "Sedan Car on Rent in Bhosari",
      "description": "Skyline Cabs offers clean and comfortable sedans on rent in Bhosari for personal and corporate travel to Mumbai. Choose from Dzire, Etios, or similar for a budget-friendly trip."
    },
    {
      "name": "Tingre Nagar to Mumbai Cabs",
      "description": "Book a cab from Tingre Nagar to Mumbai with Skyline Cabs. Enjoy timely service, comfortable vehicles, and options like Innova, Ertiga, and sedans for every travel need."
    },
    {
      "name": "Charholi to Mumbai Cab Service",
      "description": "Skyline Cabs provides reliable intercity cab service from Charholi to Mumbai. Choose from flexible pickup times, professional drivers, and well-maintained vehicles."
    },
    {
      "name": "Cab Service in Vishrantwadi",
      "description": "Skyline Cabs offers a trusted cab service in Vishrantwadi for local trips and long-distance rides. Our customer-first approach and clean cars ensure a pleasant journey every time."
    },
    {
      "name": "Cab Service in Vishrantwadi Pune",
      "description": "Get 24/7 cab service in Vishrantwadi, Pune, with Skyline Cabs. Whether for daily commute, airport drop, or Mumbai trip, we offer safe and punctual rides with professional drivers."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs specializes in Pune to Mumbai Airport transfers. Get guaranteed pickups, sanitized vehicles, and timely service to catch your flight stress-free."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Looking for the best Pune to Mumbai cab? Skyline Cabs offers one-way and round-trip options, premium and economy vehicles, and a seamless booking experience."
    }
  ],
  "tableData": [
    ["Vishrantwadi to Mumbai Cab Price", "Dhanori to Mumbai Cab Service"],
    ["Vishrantwadi to Mumbai Airport Cab", "Vishrantwadi to Dadar Cab"],
    ["Mumbai to Vishrantwadi Cab", "Bhosari to Mumbai Cabs"],
    ["Bhosari to Mumbai Cabs Service", "Cab Service in Dhanori"],
    ["Cab Service in Vishrantwadi", "Taxi Service in Vishrantwadi"],
    ["Innova Crysta on Rent in Vishrantwadi", "Innova Crysta Hire In Bhosari"],
    ["Ertiga on Rent in Vishrantwadi", "Sedan Car on Rent in Bhosari"],
    ["Tingre Nagar to Mumbai Cabs", "Charholi to Mumbai Cab Service"],
    ["Cab Service in Vishrantwadi", "Cab Service in Vishrantwadi Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Trusted Vishrantwadi to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable cab services from Vishrantwadi to Mumbai, ensuring timely pickups, smooth rides, and a stress-free travel experience. Whether it’s an urgent business trip or a planned vacation, we’ve got your travel covered."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
        "WhyChoosedescription": "Our cabs are clean, air-conditioned, and regularly maintained for your comfort and safety. Enjoy a relaxing ride from Vishrantwadi to Mumbai with plenty of legroom, smooth suspension, and all the modern amenities to make your journey enjoyable."
    },
    {
        "WhyChooseheading": "Professional and Polite Drivers",
        "WhyChoosedescription": "Skyline Cabs ensures all drivers are trained, background-verified, and courteous. Our drivers know the best and fastest routes from Vishrantwadi to Mumbai, and prioritize both your comfort and your safety during the ride."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We provide affordable pricing with no hidden fees. Get upfront fare estimates before booking your cab from Vishrantwadi to Mumbai so you can travel worry-free, knowing exactly what you’ll pay."
    },
    {
        "WhyChooseheading": "24/7 Availability from Vishrantwadi",
        "WhyChoosedescription": "Whether you're heading out early in the morning or arriving late at night, our cabs are available 24/7 from Vishrantwadi to Mumbai. Book your ride anytime, and we'll be there promptly."
    },
    {
        "WhyChooseheading": "Fleet Options for Every Need",
        "WhyChoosedescription": "Choose the vehicle that suits your journey—sedans for solo or business travel, SUVs for family trips, and luxury cars for special occasions. No matter your group size or budget, Skyline Cabs has the right vehicle for you."
    },
    {
        "WhyChooseheading": "Quick Online Booking with Live Tracking",
        "WhyChoosedescription": "Book your Vishrantwadi to Mumbai cab online in just a few clicks. Our user-friendly app and website offer instant booking, live tracking, driver details, and easy payment options for a smooth, modern travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Intercity Rides",
        "WhyChoosedescription": "Your safety is our priority. Our cabs are GPS-enabled, sanitized, and driven by verified professionals. With Skyline Cabs, you can sit back, relax, and enjoy a secure journey from Vishrantwadi to Mumbai."
    }
]



















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Vishrantwadi to Mumbai with Skyline Cabs?',
            answer:
                'You can book easily through our website or mobile app. Just select Vishrantwadi as your pickup location and Mumbai as your destination. Pick the vehicle that suits your needs, confirm the ride, and you’re good to go!',
        },
        {
            id: 2,
            question: 'What types of cabs are available for the Vishrantwadi to Mumbai route?',
            answer:
                'Skyline Cabs offers a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. You can choose based on your group size, comfort level, and budget.',
        },
        {
            id: 3,
            question: 'Are your fares from Vishrantwadi to Mumbai fixed?',
            answer:
                'Yes, all fares are fixed and transparent. The price includes tolls, taxes, and driver charges. No hidden fees — what you see at booking is what you pay.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Vishrantwadi to Mumbai?',
            answer:
                'Yes, we provide both one-way and round-trip options. Enter your return details at the time of booking and we’ll make the return journey seamless for you.',
        },
        {
            id: 5,
            question: 'How long does it take to reach Mumbai from Vishrantwadi?',
            answer:
                'It typically takes around 3.5 to 4 hours depending on traffic conditions. Our drivers know the best routes to ensure you reach safely and on time.',
        },
        {
            id: 6,
            question: 'Are drivers familiar with Vishrantwadi and long-distance routes?',
            answer:
                'Absolutely! Our drivers are experienced, background-verified, and familiar with local roads and intercity routes like Vishrantwadi to Mumbai.',
        },
        {
            id: 7,
            question: 'Can I use Skyline Cabs for Mumbai Airport transfers from Vishrantwadi?',
            answer:
                'Yes, we offer reliable pickup and drop-off services for Mumbai Domestic and International Airports. Just share your flight details, and we’ll handle the rest.',
        },
        {
            id: 8,
            question: 'Are the cabs clean and air-conditioned?',
            answer:
                'Yes, all our cabs are fully air-conditioned and regularly sanitized for your safety and comfort. We prioritize hygiene and quality.',
        },
        {
            id: 9,
            question: 'Is there customer support if I face issues during the trip?',
            answer:
                'Yes, our customer support team is available 24/7 to assist you. Whether it’s a change in schedule or any other concern, we’re just a call away.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Vishrantwadi to Mumbai travel?',
            answer:
                'Skyline Cabs offers reliable service, clean vehicles, professional drivers, and upfront pricing. We ensure a safe, comfortable, and stress-free ride from Vishrantwadi to Mumbai every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Nikhil Jadhav",
            rating: 5,
            review: "I booked a Sedan from Vishrantwadi to Mumbai for a client meeting. The car was spotless, the driver was courteous, and I reached well ahead of time. Very reliable service from Skyline Cabs."
        },
        {
            name: "Miss. Pooja Kulkarni",
            rating: 4,
            review: "Had a great trip from Vishrantwadi to Mumbai with Skyline Cabs. The car was comfortable, and the driver was very professional. Would love if there were charging ports available, but otherwise, excellent ride!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vishrantwadi to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/vishrantwadi-to-mumbai-cab.jpg",
  "description": "Book Vishrantwadi to Mumbai cabs with Skyline Cabs for a reliable and affordable travel experience. Enjoy 24/7 AC cab service with professional drivers for one-way or round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7324"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/vishrantwadi-to-mumbai-cabs"
  }
};



      
     


    return (
        <div>

<Helmet>
  <title>Vishrantwadi to Mumbai Cabs | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Vishrantwadi to Mumbai cabs with Skyline Cabs for a reliable and affordable travel experience. Enjoy 24/7 AC cab service with professional drivers for one-way or round-trip journeys." 
  />
  <meta 
    name="keywords" 
    content="Vishrantwadi to Mumbai Cabs, Cab from Vishrantwadi to Mumbai, One-Way Taxi Vishrantwadi to Mumbai, Round Trip Cab Vishrantwadi to Mumbai, AC Cab Vishrantwadi to Mumbai, SUV Taxi Vishrantwadi to Mumbai, Affordable Cab Service Vishrantwadi to Mumbai, Online Cab Booking Vishrantwadi to Mumbai, Skyline Cabs Vishrantwadi to Mumbai, 24/7 Vishrantwadi to Mumbai Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vishrantwaditomumbaicab;